import {
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { track } from '@eventbrite/datalayer-library';
import { Icon } from '@eventbrite/eds-icon';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { Location } from 'history';
import React, { MouseEventHandler, useState } from 'react';
import { Sticky } from 'react-sticky';
import { DateType } from '../../../../constants/dates';
import { CategoryBrowseBucketHeader } from '../../components/CategoryBrowseBucket';
import {
    CATEGORY_KEY_TO_URL_PARAM,
    DEFAULT_NIGHTLIFE_TAB,
    NightlifeTabs,
    NightlifeTabsSearchQuery,
} from '../../constants/nightLife';
import { useRouteContext, useSearchContext } from '../../context';
import './NightlifeCategoriesContainer.scss';
interface CardContent {
    title: string | GenericLazyString;
    icon?: JSX.Element;
    onClick?: MouseEventHandler<HTMLDivElement>;
    selectedCard: boolean;
}
const NightlifeCategoryCard = (props: CardContent) => {
    const { title, icon, selectedCard, onClick } = props;
    const classes = selectedCard ? 'selected_card' : '';
    return (
        <div className={`nightlife-category-card ${classes}`} onClick={onClick}>
            <aside className="nightlife-category-card--icon">
                <Icon
                    type={icon}
                    color={selectedCard ? 'boost-purple' : null}
                />
            </aside>
            <p className="nightlife-category-card--name eds-text-weight--heavy">
                {title}
            </p>
        </div>
    );
};

const useNightlifeCategoryTracking = () => {
    const trackNightlifePageCategory = (
        location: Location<string> | undefined,
        categoryKey: string,
    ) => {
        // Use your tracking library here
        track({
            eventName: 'NightlifePageCategory',
            eventData: {
                searchLocation: location,
                category: categoryKey,
            },
        });
    };

    return trackNightlifePageCategory;
};

const useCategoryQueryUpdater = () => {
    const { setQuery } = useSearchContext();

    const updateSearchQuery = (categoryKey: string, parsedDate: DateType[]) => {
        const query = NightlifeTabsSearchQuery[categoryKey];

        if (categoryKey !== 'Tonight' && categoryKey !== 'ThisWeekend') {
            query['dates'] = parsedDate;
        }

        if (query && setQuery) {
            setQuery(query);
        }
    };

    return updateSearchQuery;
};

const calculateTopOffset = () => {
    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window?.innerWidth <= 768;
    }
    return isMobile ? 0 : 100;
};
export const NightlifeCategoriesContainer = () => {
    const { location, parsedValues, history } = useRouteContext();
    const [tabValue, setTab] = useState(
        parsedValues?.category || DEFAULT_NIGHTLIFE_TAB,
    );
    const trackNightlifePageCategory = useNightlifeCategoryTracking();
    const updateSearchQuery = useCategoryQueryUpdater();

    const handleCategoryClick = (
        categoryKey: string,
        categoryUrlParam: string,
    ) => {
        const parsedDate = parsedValues?.date
            ? [parsedValues?.date]
            : ['current_future'];
        if (parsedValues) {
            parsedValues.category = categoryKey;
        }
        const params = new URLSearchParams(location?.search);
        params.set('category', categoryUrlParam || categoryKey);
        updateRoute(params);
        setTab(parsedValues?.category || categoryKey);
        trackNightlifePageCategory(
            location,
            parsedValues?.category || categoryKey,
        );
        updateSearchQuery(
            parsedValues?.category || categoryKey,
            parsedDate as DateType[],
        );
    };

    const updateRoute = (params: URLSearchParams) => {
        const pathname =
            location?.pathname ||
            `/b/online/${EVENTBRITE_CATEGORY_TO_REFINEMENT[NIGHTLIFE_EVENTBRITE_CATEGORY]}/`;
        const path = `${pathname}?${params.toString()}`;
        history?.push(path);
    };

    const topOffset = calculateTopOffset();
    return (
        <Sticky topOffset={topOffset}>
            {({ style, isSticky }) => (
                <div style={{ ...style, zIndex: 1000 }}>
                    <div
                        className={`nightlife-categories-container ${
                            isSticky && 'sticky-container'
                        }`}
                    >
                        <CategoryBrowseBucketHeader>
                            {gettext("Explore what's popular within Nightlife")}
                        </CategoryBrowseBucketHeader>

                        <div
                            className={`nightlife-categories-container-bucket`}
                        >
                            {NightlifeTabs.map((category) => (
                                <NightlifeCategoryCard
                                    key={category.key}
                                    title={category.name}
                                    icon={category.icon}
                                    selectedCard={category.key === tabValue}
                                    onClick={() =>
                                        handleCategoryClick(
                                            category.key,
                                            CATEGORY_KEY_TO_URL_PARAM[
                                                category.key
                                            ],
                                        )
                                    }
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </Sticky>
    );
};
